import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminFuneralModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminFuneralModule;